import Route from '@ember/routing/route';

export default class AppServicesRoute extends Route {}
